import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface ExpedienteConfiguracion {
  formato: string;
  prefijo: string;
  longitud: number;
  consecutivoActual: number;
}

export interface ActualizarExpedienteConfiguracion {
  formato: string;
  prefijo: string;
  longitud: number;
}

@Injectable({
  providedIn: 'root',
})
export class ConfiguracionExpedienteService {
  private apiUrl = `${environment.apiUrl}/expediente-configuracion`;

  constructor(private http: HttpClient) {}

  actualizarExpediente(
    configuracion: ActualizarExpedienteConfiguracion,
  ): Observable<ExpedienteConfiguracion> {
    return this.http.patch<ExpedienteConfiguracion>(this.apiUrl, configuracion);
  }
}
